import keyMirror from "keymirror";

export default keyMirror({
  STATIC_CACHE_VERSIONS_WILL_GET: null,
  STATIC_CACHE_VERSIONS_DID_GET: null,
});
